import { render, staticRenderFns } from "./AccountConfirmation.vue?vue&type=template&id=bd5b7598"
import script from "./AccountConfirmation.vue?vue&type=script&lang=js"
export * from "./AccountConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AccountConfirmation.vue?vue&type=style&index=0&id=bd5b7598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports